import pubsub from 'pubsub.js';

export const EVENT = {
    LAYOUT_ADD_CLASS: 'layout/add_class',
    LAYOUT_DEL_CLASS: 'layout/del_class',
};

export default pubsub;
